// SolarSim — dev-only logger. In production builds these are no-ops so
// nothing is written to the browser console and no runtime overhead beyond
// the (compile-time-inlinable) env check.
const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export function warn(...args) {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}

export function error(...args) {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
